// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"10c1c723","703":"9d0409b8"}[chunkId] + ".chunk.js";
};